import {useContext, useEffect} from 'react';
import {CookieConsentContext} from '../../../../utils/cookiesUtil';

const useYandexMetrika = () => {
  const {cookieConsent} = useContext(CookieConsentContext);

  useEffect(() => {
    if (cookieConsent?.analytical) {
      const {head} = document;
      const elements = [];

      elements.push(document.createElement('script'));
      elements[0].type = 'text/javascript';
      elements[0].textContent = `
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        ym(92283436, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
        });
      `;

      elements.push(document.createElement('noscript'));
      elements[1].appendChild(document.createElement('div'));
      elements[1].children[0].appendChild(document.createElement('img'));
      elements[1].children[0].children[0].src = 'https://mc.yandex.ru/watch/92283436';
      elements[1].children[0].children[0].style = 'position:absolute; left:-9999px;';
      elements[1].children[0].children[0].alt = '';

      elements.push(document.createElement('script'));
      elements[2].textContent = `
        const domain = window.location.hostname;
        switch (domain) {
        case '%REACT_APP_DOMAIN_RU%':
        apiUrl = '%REACT_APP_API_URL_RU%';
        break;
        case '%REACT_APP_DOMAIN_BY%':
        apiUrl = '%REACT_APP_API_URL_BY%';
        break;
        case '%REACT_APP_DOMAIN_COM%':
        apiUrl = '%REACT_APP_API_URL_COM%';
        break;
        default:
        apiUrl = '%REACT_APP_API_URL_RU%';
        break;
        }

        var botmanWidget = {
          frameEndpoint: '/botman.html',
          title: 'Поддержка',
          aboutText: null,
          placeholderText: null,
          chatServer: apiUrl + 'bot',
          bubbleBackground: 'rgba(0,0,0,0)',
          desktopWidth: 390,
          desktopHeight: 468
        };
      `;

      const start = document.createComment('Yandex.Metrika counter');
      const end = document.createComment('Yandex.Metrika counter END');

      head.prepend(start, ...elements, end);
    }
  }, []);

  return <></>;
};

export default useYandexMetrika;
